export default __webpack_public_path__ + "static/media/dashboard-desktop.613186ab.png";